// scroll event
document.addEventListener('DOMContentLoaded', () => {
	const body = document.body;
	const html = document.documentElement;
	var docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.scrollHeight, html.offsetHeight) - html.clientHeight;
	var lastKnownScrollPosition = 0, ticking = false, percentScrolled, scrolled = new Set();
	window.addEventListener('resize', (e) => { docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.scrollHeight, html.offsetHeight) - html.clientHeight })
	document.addEventListener('scroll', scrollListener);

	// Listen for scrolling
	function scrollListener() {
		lastKnownScrollPosition = window.scrollY;
		if (!ticking) {
			window.requestAnimationFrame(() => {
				trackScroll(lastKnownScrollPosition);
				ticking = false;
			});
			ticking = true;
		}
	}

	// Track scroll position
	function trackScroll(scrollPos) {
		percentScrolled = (Math.floor((scrollPos / docHeight) * 4) / 4) * 100;
		scrollEvent(percentScrolled);
	}

	// Send each scroll percentage only once
	function scrollEvent(s) {
		if (s != 0 && !scrolled.has(s)) {
			// Scroll event
            Shopify.analytics.publish('yarrow_scroll', {
              event: 'scroll',
              percent_scrolled: s
            });
			scrolled.add(s);
		}
		if (s == 100) { document.removeEventListener('scroll', scrollListener) }
		return;
	}
})